<template>
  <div id="form-cronograma">
    <v-btn color="lime darken-2" dark class="mb-3" @click="volver()">
      <v-icon right dark>arrow_back_ios</v-icon>Volver
    </v-btn>
    <v-container grid-list-xl>
      <v-card>
        <v-toolbar color="white" dark flat dense cad>
          <v-toolbar-title class="indigo--text">{{
            titleView
          }}</v-toolbar-title>
        </v-toolbar>
        <v-layout>
          <v-flex xs12 md1></v-flex>
          <v-flex xs12 md12>
            <!-- INICIO DATOS DE REVISION -->
            <template>
              <v-form ref="form" v-model="validacion" lazy-validation>
                <v-layout>
                  <v-spacer></v-spacer>
                  <v-flex xs12 md4>
                    <v-menu
                      v-model="menu1"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="fechaTraspaso"
                          label="Fecha Traspaso"
                          prepend-icon="event"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="fechaTraspaso"
                        no-title
                        @input="menu1 = false"
                        locale="es"
                        first-day-of-week="1"
                      >
                      </v-date-picker>
                    </v-menu>
                    <v-select
                      v-model="horaAgendaValue"
                      :items="horaAgendaSelect"
                      item-text="nombre"
                      item-value="code"
                      label="Hora"
                      :box="tipeView == 'consulta'"
                      :readonly="tipeView == 'consulta'"
                      @input="$v.horaAgendaValue.$touch()"
                      @blur="
                        tipeView == 'crear' ? $v.horaAgendaValue.$touch() : null
                      "
                    ></v-select>
                  </v-flex>
                </v-layout>
                <v-layout>
                  <v-flex>
                    <v-select
                      v-model="regionValue"
                      :items="regionesSelect"
                      item-text="nombre"
                      item-value="code"
                      label="Region"
                      :box="tipeView == 'consulta'"
                      :readonly="tipeView == 'consulta'"
                      @change="loadCentrosRegion()"
                      @input="$v.regionValue.$touch()"
                      @blur="
                        tipeView == 'crear' ? $v.regionValue.$touch() : null
                      "
                    ></v-select>
                    <v-select
                      v-model="centroOrigenValue"
                      :items="centroOrigenSelect"
                      item-text="nombre"
                      item-value="code"
                      label="Centro de Acopio Origen"
                      :box="tipeView == 'consulta'"
                      :readonly="tipeView == 'consulta'"
                      @input="$v.centroOrigenValue.$touch()"
                      @blur="
                        tipeView == 'crear'
                          ? $v.centroOrigenValue.$touch()
                          : null
                      "
                    ></v-select>
                    <v-select
                      v-model="centroDestinoValue"
                      :items="centroDestinoSelect"
                      item-text="nombre"
                      item-value="code"
                      label="Centro de Operacion Destino"
                      :box="tipeView == 'consulta'"
                      :readonly="tipeView == 'consulta'"
                      @input="$v.centroDestinoValue.$touch()"
                      @blur="
                        tipeView == 'crear'
                          ? $v.centroDestinoValue.$touch()
                          : null
                      "
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 md1></v-flex>
                  <v-flex>
                    <v-select
                      v-model="materialValue"
                      :items="materialSelect"
                      item-text="nombre"
                      item-value="code"
                      label="Tipo Material"
                      :box="tipeView == 'consulta'"
                      :readonly="tipeView == 'consulta'"
                      @input="$v.materialValue.$touch()"
                      @blur="
                        tipeView == 'crear' ? $v.materialValue.$touch() : null
                      "
                    ></v-select>
                    <v-text-field
                      v-model="materialComplementario"
                      :error-messages="materialComplementarioErrors"
                      label="Material Complementario"
                      :box="tipeView == 'consulta'"
                      type="number"
                      :readonly="tipeView == 'consulta'"
                      @input="$v.materialComplementario.$touch()"
                      @blur="
                        tipeView == 'crear'
                          ? $v.materialComplementario.$touch()
                          : null
                      "
                    ></v-text-field>
                    <v-text-field
                      v-model="materialAplicacion"
                      :error-messages="materialAplicacionErrors"
                      label="Material Aplicacion"
                      :box="tipeView == 'consulta'"
                      type="number"
                      :readonly="tipeView == 'consulta'"
                      @input="$v.materialAplicacion.$touch()"
                      @blur="
                        tipeView == 'crear'
                          ? $v.materialAplicacion.$touch()
                          : null
                      "
                    ></v-text-field>
                    <v-select
                      v-model="nivelValue"
                      :items="nivelSelect"
                      item-text="nombre"
                      item-value="code"
                      label="Nivel"
                      :box="tipeView == 'consulta'"
                      :readonly="tipeView == 'consulta'"
                      @input="$v.nivelValue.$touch()"
                      @blur="
                        tipeView == 'crear' ? $v.nivelValue.$touch() : null
                      "
                    ></v-select>
                  </v-flex>
                </v-layout>
              </v-form>
            </template>
            <!-- TERMINO DATOS DE REVISION-->
          </v-flex>
          <v-flex xs12 md1></v-flex>
        </v-layout>
        <!-- --------------------------------------------- -->
        <v-card-actions class="pb-3">
          <v-spacer></v-spacer>
          <v-btn
            v-if="tipeView == 'crear' || tipeView == 'modifica'"
            :loading="loading"
            color="primary"
            @click="save()"
            >Guardar <v-icon right dark>save</v-icon></v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-container>
  </div>
</template>
<script>
import { validationMixin } from "vuelidate";
import { required, maxLength, email } from "vuelidate/lib/validators";
import { error } from "util";
import { misMixins } from "@/mixins/myMixing.js";
import { mapState, mapActions } from "vuex";
import axios from "axios";
import AlertEmpty from "@/views/ui/AlertEmpty.vue";

export default {
  name: "FormCronograma",
  components: {
    AlertEmpty,
  },
  mixins: [misMixins, validationMixin],
  props: {
    rowsTable: "",
  },

  data() {
    return {
      loading: false,
      alertaRecibidos: false,
      dialog: false,
      visibleNew: false,
      userlogged: "",
      horaAgendaValue: "",
      horaAgendaSelect: [
        { nombre: "08:00", code: "08:00" },
        { nombre: "09:00", code: "09:00" },
        { nombre: "10:00", code: "10:00" },
        { nombre: "11:00", code: "11:00" },
        { nombre: "12:00", code: "12:00" },
        { nombre: "13:00", code: "13:00" },
        { nombre: "14:00", code: "14:00" },
        { nombre: "15:00", code: "15:00" },
        { nombre: "16:00", code: "16:00" },
        { nombre: "17:00", code: "17:00" },
        { nombre: "18:00", code: "18:00" },
        { nombre: "19:00", code: "19:00" },
        { nombre: "20:00", code: "20:00" },
      ],
      regionValue: "",
      regionesSelect: [],
      cronograma: "",
      centroAcopio: "",
      centroOrigenValue: "",
      centroOrigenSelect: [],
      centroOperacion: "",
      centroDestinoValue: "",
      centroDestinoSelect: [],
      fechaTraspaso: "",
      material: "",
      materialValue: "",
      materialSelect: [],
      cajaContenedora: "",
      cajaDia1: "",
      cajaDia2: "",
      codCurso: "",
      tipoMaterialValue: "",
      tipoMaterialSelect: [],
      materialComplementario: "",
      materialAplicacion: "",
      dataNivel: "",
      nivelValue: "",
      nivelSelect: [],
      resultadoValue: "",
      resultadoSelect: [],
      motivoErrorValue: "",
      motivoErrorSelect: [],
      cajaContingenciaUsada: "",
      observacion: "",
    };
  },

  validations: {
    fechaRevision: { required },
    centroValue: { required },
    cajaContenedora: { required },
    cajaDia1: { required },
    cajaDia2: { required },
    tipoMaterialValue: { required },
    rbd: { required },
    curso: { required },
    nivelValue: { required },
    resultadoValue: { required },
    motivoErrorValue: { required },
    usoMaterialContingenciaValue: { required },
    usoMaterialContingenciaValue: { required },
    cajaContingenciaUsada: { required },
    observacion: { required },
  },

  created() {
    this.tipeCenter = this.$store.getters.subTabSelectedStored;
    this.titleView = this.$route.params.titleView;
    this.idContrato = this.$store.getters.contratoStored;

    if (this.tipeView === undefined) {
      this.tipeView = this.$route.params.tipeView;
    }
    if (this.tipeView == "consulta") {
      this.idCronograma = this.$route.params.idCronograma;
      this.userlogged = this.$store.getters.userLogged.tipo;
      this.loadData();
    }
    if (this.tipeView == "crear") {
      this.tipoCentroSelect = [this.$store.getters.subTabSelectedStored];
      this.tipoCentroValue = this.$store.getters.subTabSelectedStored;
      this.loadDataComuna();
      this.loadDataMaterial();
      this.loadDataNivel();
    }
    //   if (this.tipeView == "modifica") {
    //   this.idCronograma = this.$route.params.idCronograma;
    //   this.idContrato = this.$store.getters.contratoStored;
    //   this.userlogged = this.$store.getters.userLogged.tipo;
    //   this.loadDataComuna();
    //   this.loadData();
    // }
    if (this.userlogged == "PROVEEDOR") {
      this.visibleNew = true;
    } else {
      this.visibleNew = false;
    }
  },
  mounted() {},
  computed: {
    telefonoEncargadoErrors() {
      const errors = [];
      if (!this.$v.telefonoEncargado.$dirty) return errors;
      !this.$v.telefonoEncargado.required &&
        errors.push("Telefono es requerido.");
      return errors;
    },

    selectErrors() {
      const errors = [];
      if (!this.$v.tipoCentroValue.$dirty) return errors;
      !this.$v.tipoCentroValue.required && errors.push("Item es requerido");
      return errors;
      if (!this.$v.regionValue.$dirty) return errors;
      !this.$v.regionValue.required && errors.push("Item es requerido");
      return errors;
      if (!this.$v.comunaValue.$dirty) return errors;
      !this.$v.comunaValue.required && errors.push("Item es requerido");
      return errors;
    },
  },
  methods: {
    async loadCentrosRegion() {
      await this.loadCentrosAcopio();
      await this.loadCentrosOperacion();
    },

    //  CENTROS POR REGION ORIGEN
    async loadCentrosAcopio() {
      this.centroAcopio = await this.loadCentroAcopioData();
      let centros = [];
      this.centroAcopio.forEach(function (c) {
        centros.push({ nombre: c.code, code: c.id });
      });
      this.centroOrigenSelect = centros;
    },
    async loadCentroAcopioData() {
      var that = this;

      return await axios
        .get(
          "/traspasoCaCo/centroAcopio/" +
            this.idContrato +
            "/" +
            this.regionValue
        )
        .then((response) => {
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
          return [];
        });
    },

    //  CENTROS POR REGION DESTINO
    async loadCentrosOperacion() {
      this.centroOperacion = await this.loadCentroOperacionData();
      let centros = [];
      this.centroOperacion.forEach(function (c) {
        centros.push({ nombre: c.code, code: c.id });
      });
      this.centroDestinoSelect = centros;
    },
    async loadCentroOperacionData() {
      var that = this;
      return await axios
        .get(
          "/traspasoCaCo/centroOperacion/" +
            this.idContrato +
            "/" +
            this.regionValue
        )
        .then((response) => {
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
          return [];
        });
    },

    //  CENTROS POR REGION DESTINO
    async loadDataMaterial() {
      this.material = await this.loadMaterialData();
      let materiales = [];
      this.material.forEach(function (c) {
        materiales.push({ nombre: c.descripcion, code: c.id });
      });
      this.materialSelect = materiales;
    },
    async loadMaterialData() {
      var that = this;
      return await axios
        .get("/traspasoCaCo/materiales/" + this.idContrato)
        .then((response) => {
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
          return [];
        });
    },
    async loadNivel() {
      let that = this;
      let idContrato = this.$store.getters.contratoStored;
      return axios
        .get("/nivel/" + idContrato)
        .then(function (response) {
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
          return [];
        });
    },
    async loadDataNivel() {
      this.dataNivel = await this.loadNivel();
      let tipo = [];
      this.dataNivel.forEach(function (t) {
        tipo.push({
          nombre: t.description,
          code: t.code,
        });
      });
      this.nivelSelect = tipo;
      this.nivelValue = this.nivelSelect;
    },

    getRegionName(regionId) {
      let encontrar = this.genRegionComuna.find(function (x) {
        return x.id == regionId;
      });
      return encontrar.nombre;
    },

    async loadData() {
      this.cronograma = await this.loadCronogramaData();
      (this.materialComplementario = this.cronograma.mat_complementario),
        (this.materialAplicacion = this.cronograma.mat_aplicacion),
        (this.fechaTraspaso = this.formatoFecha(
          this.cronograma.fecha_movimiento
        )),
        //this.codCurso = this.cronograma.codCurso,
        (this.horaAgendaValue = {
          nombre: this.cronograma.hora_movimiento,
          code: this.cronograma.hora_movimiento,
        });
      this.horaAgendaSelect = [
        {
          nombre: this.cronograma.hora_movimiento,
          code: this.cronograma.hora_movimiento,
        },
      ];
      this.nivelValue = {
        nombre: this.cronograma.nivel.descripcion,
        code: this.cronograma.nivel.descripcion,
      };
      this.nivelSelect = [
        {
          nombre: this.cronograma.nivel.descripcion,
          code: this.cronograma.nivel.descripcion,
        },
      ];
      this.materialValue = {
        nombre: this.cronograma.material.id,
        code: this.cronograma.material.id,
      };
      this.materialSelect = [
        {
          nombre: this.cronograma.material.descripcion,
          code: this.cronograma.material.id,
        },
      ];
      this.regionValue = {
        nombre: this.cronograma.region.nombre,
        code: this.cronograma.region.nombre,
      };
      this.regionesSelect = [
        {
          nombre: this.cronograma.region.nombre,
          code: this.cronograma.region.nombre,
        },
      ];
      this.centroOrigenValue = {
        nombre: this.cronograma.centroOrigen.codCentro,
        code: this.cronograma.centroOrigen.codCentro,
      };
      this.centroOrigenSelect = [
        {
          nombre: this.cronograma.centroOrigen.codCentro,
          code: this.cronograma.centroOrigen.codCentro,
        },
      ];
      this.centroDestinoValue = {
        nombre: this.cronograma.centroDestino.codCentro,
        code: this.cronograma.centroDestino.codCentro,
      };
      this.centroDestinoSelect = [
        {
          nombre: this.cronograma.centroDestino.codCentro,
          code: this.cronograma.centroDestino.codCentro,
        },
      ];
    },

    async loadCronogramaData() {
      var that = this;
      return await axios
        .get("/cronograma/id/" + this.idCronograma + "/" + this.idContrato)
        .then((response) => {
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
          return [];
        });
    },

    save() {
      if (this.tipeView == "crear") {
        this.loading = true;
        this.saveCronograma();
        this.loading = false;
      } else {
        this.loading = true;
        this.editRevision();
        this.loading = false;
      }
    },

    saveCronograma() {
      this.loading = true;
      let idContrato = this.$store.getters.contratoStored;
      this.body = {
        idContrato: idContrato,
        region: this.regionValue,
        centroOrigen: this.centroOrigenValue,
        centroDestino: this.centroDestinoValue,
        idMaterial: this.materialValue,
        mat_complementario: this.materialComplementario,
        mat_aplicacion: this.materialAplicacion,
        fecha_movimiento: this.formatoFecha(this.fechaTraspaso),
        hora_movimiento: this.horaAgendaValue,
        nivel: this.nivelValue,
        tipo_cronograma: "CA-CO",
      };
      axios
        .post("/traspasoCaCo/AgendarCronograma", this.body)
        .then((response) => {
          this.resp = response.data;
          this.loading = false;
          window.getApp.$emit("APP_SAVE");
          this.volver();
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
            window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
            this.loading = false;
          }
        });
    },

    volver() {
      setTimeout(() => {
        this.$router.push({
          name: "ProcesoAplicacion",
        });
      }, 1000);
    },
  },
};
</script>
